import * as HubLoginCore from './index.js';
import { findOwnScript, readScriptConfig } from './config.js';
import { defineElement } from './element.js';

if (typeof window !== 'undefined') {
  window.HubLogin = {
    init: HubLoginCore.init,
    configure: HubLoginCore.configure,
    open: HubLoginCore.open,
    close: HubLoginCore.close,
    logout: HubLoginCore.logout,
    getToken: HubLoginCore.getToken,
    isAuthenticated: HubLoginCore.isAuthenticated,
  };

  // Zero-config boot: reading the <script> tag must happen now, while
  // document.currentScript is still valid.
  const scriptConfig = readScriptConfig(findOwnScript());

  // Register as defaults immediately, so a site that calls init() from its own
  // inline script (which runs before DOMContentLoaded) still inherits them.
  HubLoginCore.setScriptDefaults(scriptConfig);

  if (scriptConfig.autoInit === false) {
    // Site drives init() itself; <hub-login> still works once it does.
    defineElement();
  } else {
    const boot = () => {
      try {
        // Don't clobber a site that already called init() itself.
        if (!HubLoginCore.wasInitialised()) HubLoginCore.init({});
      } catch (err) {
        console.error('[HubLogin] auto-init failed:', err);
      }
      // Defined after init so <hub-login> attributes merge onto the
      // script-tag config instead of being overwritten by it.
      defineElement();
    };
    // Needs <body> to exist (the modal is appended to it).
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }
}
